import './ProfileDropdown.scss';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import {
  setAmazonDataImportStatus,
  setHasNewAmazonCredentials,
} from '../../core/store/amazon/amazonSlice';
import { clearUserState } from '../../core/store/user/userSlice';
import { getColor } from '../Participants/Participants';
import HoverDropdown from '../HoverDropdown/HoverDropdown';
import { removeTokens } from '../../core/helpers';
import Button from '../Button';

interface Props {
  className?: string;
}

const ProfileDropdown = ({ className = '' }: Props) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const history = useHistory();
  const user = useAppSelector((s) => s.user.user);

  const onLogoutClick = () => {
    dispatch(clearUserState());
    dispatch(setAmazonDataImportStatus(undefined));
    dispatch(setHasNewAmazonCredentials(false));
    removeTokens();
    history.push('/');
  };

  if (!user) return null;

  return (
    <HoverDropdown
      className='HoverDropdown--ProfileDropdown'
      arrow={false}
      trigger={
        <div
          className={`ProfileDropdown__trigger px-2 px-xxl-3 rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 text-uppercase ${className}`}
          data-testid='profile-dropdown'
          style={{
            backgroundColor: getColor(user.Name),
          }}
        >
          {user.Name[0]}
          {user.FamilyName[0]}
        </div>
      }
    >
      <div className='py-2'>
        <Button
          styling='naked'
          className='w-100 text-decoration-none ProfileDropdown__dropdownItem text-center text-nowrap'
          onClick={onLogoutClick}
          tabIndex={-1}
        >
          {t('Log Out')}
        </Button>
      </div>
    </HoverDropdown>
  );
};

export default ProfileDropdown;
